import { Enums } from '@bode-canada/core';
import ServerlessApiService from '../../ServerlessApiService';

const {
  AddressesDictionaryApiPathEnum,
  AddressesApiPathEnum,
  ServerlessApiPathEnum,
} = Enums;

export default class AddressDictionaryApiService {
  static ADDRESS_BASE_URL = `/${AddressesApiPathEnum.ADDRESSES}/${ServerlessApiPathEnum.V1}`;

  static BASE_URL = `${this.ADDRESS_BASE_URL}/${AddressesDictionaryApiPathEnum.DICTIONARY}`;

  static getCitiesByProvince(province) {
    return ServerlessApiService.get(`${this.BASE_URL}/${AddressesDictionaryApiPathEnum.PROVINCE}/${province}`);
  }

  static getCityDictionaries(city) {
    return ServerlessApiService.get(`${this.BASE_URL}/${AddressesDictionaryApiPathEnum.CITY}/${city}`);
  }
}
